import React from 'react';

const FlightSummaryTable = ({ selectedFlights }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  if (!selectedFlights || selectedFlights.length === 0) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm mb-6">
      <div className="p-6 max-sm:p-4">
        <h5 className="text-lg font-bold text-jet-gray-900 mb-4">Flight Summary</h5>
        <div className="overflow-x-auto px-2 max-sm:px-0">
          <table className="w-full border border-jet-gray-200 max-sm:min-w-[640px]" style={{ border: '1px solid #dee2e6' }}>
            <thead className="bg-jet-gray-50">
              <tr style={{ border: '1px solid #dee2e6' }}>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>Flight Number</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>Departure</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>ETD</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>Arrival</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>ETA</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-jet-blue-600" style={{ border: '1px solid #dee2e6' }}>Flight Time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dashed divide-gray-400">
              {selectedFlights.map((aircraft) => (
                <tr key={aircraft.id} className="border-b border-dashed border-gray-400" style={{ border: '1px solid #dee2e6' }}>
                  <td className="px-4 py-3 text-sm text-jet-gray-900 uppercase" style={{ border: '1px solid #dee2e6' }}>{aircraft.flight_number}</td>
                  <td className="px-4 py-3 text-sm text-jet-gray-900 uppercase" style={{ border: '1px solid #dee2e6' }}>{aircraft.dep_airport_code}</td>
                  <td className="px-4 py-3 text-sm text-jet-gray-900" style={{ border: '1px solid #dee2e6' }}>
                    {formatDate(aircraft.departure_date_time)}, {formatTime(aircraft.departure_date_time)}
                  </td>
                  <td className="px-4 py-3 text-sm text-jet-gray-900 uppercase" style={{ border: '1px solid #dee2e6' }}>{aircraft.arr_airport_code}</td>
                  <td className="px-4 py-3 text-sm text-jet-gray-900" style={{ border: '1px solid #dee2e6' }}>
                    {formatDate(aircraft.arrival_date_time)}, {formatTime(aircraft.arrival_date_time)}
                  </td>
                  <td className="px-4 py-3 text-sm text-jet-gray-900" style={{ border: '1px solid #dee2e6' }}>
                    {aircraft.diff_hours}h {aircraft.diff_mins}m
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FlightSummaryTable;
